import { AnonymousStatusError } from "@impero-com/common/errorPages/anonymousError";
import { AjaxManager } from "@impero-com/common/utils/ajax";
import { Meta, withHeader } from "@impero-com/common/utils/header";
import withI18n, { t } from "@impero-com/common/utils/i18n";
import { Route, Routes, useLocation } from "react-router-dom";

import { AutoRedirectWrapper } from "../noOrg/autoRedirectWrapper";
import CheckInbox from "../noOrg/checkInbox";
import ForgotPassword from "../noOrg/forgotPassword";
import ForgotTeam from "../noOrg/forgotTeam";
import LinkExpired from "../noOrg/linkExpired";
import { TeamList } from "../noOrg/teamList";
import TeamLogin from "../noOrg/teamLogin";
import { WebRoute } from "../routes";

interface AppProps {
    ajaxManager: AjaxManager;
}

function App({ ajaxManager }: AppProps) {
    const location = useLocation();
    const redirectPath =
        location.pathname === WebRoute.OAUTH_AUTHORIZE
            ? location.pathname + location.search
            : undefined;

    return (
        <>
            <Meta title={() => t("Login_Title")} />
            <AutoRedirectWrapper redirectPath={redirectPath}>
                <Routes>
                    <Route
                        path="/"
                        element={<TeamLogin ajaxManager={ajaxManager} />}
                    />

                    <Route
                        path={WebRoute.OAUTH_AUTHORIZE}
                        element={
                            <TeamLogin
                                ajaxManager={ajaxManager}
                                redirectPath={redirectPath}
                            />
                        }
                    />
                    <Route
                        path="/forgot"
                        element={<ForgotTeam ajaxManager={ajaxManager} />}
                    />
                    <Route path="/check" element={<CheckInbox />} />
                    <Route path="/password" element={<ForgotPassword />} />
                    <Route path="/expired" element={<LinkExpired />} />
                    <Route
                        path="/choose-org/:token"
                        element={<TeamList ajaxManager={ajaxManager} />}
                    />
                    <Route
                        path="*"
                        element={
                            <>
                                <Meta title={() => t("ErrorPage_NotFound")} />
                                <AnonymousStatusError code={404} />
                            </>
                        }
                    />
                </Routes>
            </AutoRedirectWrapper>
        </>
    );
}

export const AppNoOrg = withI18n<AppProps>(withHeader<AppProps>(App));
